<div class="admin-container">
    <div  class="admin-form"> 
        <div style="text-align: center; padding: 0 0 24px 0;" (click)="goHome()">
            <img width="40" alt="Zulu logo" src="/assets/images/logo.jpg" />
        </div>

      <div>
        <app-login *ngIf="!auth._user"></app-login>
        <app-reports-main *ngIf="auth._user" style="width: 100%;"></app-reports-main>
      </div>
    </div>
  </div>
  <button mat-raised-button color="accent" class="logout" (click)="logout()" *ngIf="auth._user">Logout</button>